<img
  alt="{{ source }} icon"
  [escape]="false"
  class="{{ imgClass }}"
  [ngClass]="{ 'max-height-unset': useOriginalHeight }"
  src="{{ assetUrl }}/icons/{{ source }}.svg"
/>
